import _ from 'lodash';
import store from './store';
import { isObjectNotEmpty } from './tools';

export const isDeliveryPriceInKm = () => {
  const { generalConfig, shop = {} } = store.getState().firebaseRealTime;
  const { isAllShops } = store.getState().user;
  const { delivery: shopDelivery = {} } = shop?.configuration || {}
  const { userServicePrice } = generalConfig?.delivery || {}
  const { userServicePrice: shopUserServicePrice } = shopDelivery;

  return _.cloneDeep(shopUserServicePrice && !isAllShops ? shopUserServicePrice : userServicePrice);
};

export const getDriverServicePrice = () => {
  const { shop = {}, generalConfig } = store.getState().firebaseRealTime;
  const { isAllShops } = store.getState().user;
  const { driverServicePrice } = generalConfig?.delivery || {}
  const { driverServicePrice: shopDriverServicePrice } = shop?.configuration?.delivery || {}
  return _.cloneDeep(
    shopDriverServicePrice && !isAllShops ? shopDriverServicePrice : driverServicePrice
  )
}

export const isShopUserServicePrice = () => {
  const { shop = {} } = store.getState().firebaseRealTime;
  const { userServicePrice = {} } = shop?.configuration?.delivery || {}
  return isObjectNotEmpty(userServicePrice);
}

export const isFreelanceEnabled = (shopId) => {
  const { shops = {}, generalConfig = {} } = store.getState().firebaseRealTime
  const generalConfigFreelanceEnabled = generalConfig?.delivery?.freelance || false
  if (generalConfigFreelanceEnabled) {
    const shopFreelanceEnabled = shops[shopId]?.configuration?.delivery?.freelance
    if (typeof shopFreelanceEnabled === 'boolean') return shopFreelanceEnabled
  }
  return generalConfigFreelanceEnabled
}